import { Link } from "react-router-dom";
import { Mail, BookOpen } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { assetUrl } from "@/lib/api";
import { Rich } from "@/components/site/Rich";
import { PageBand } from "@/components/site/PageBand";

export default function Buy() {
  const { content } = useSite();
  const b = content.buy;
  useSeo("buy");
  return (
    <div className="font-arial-all" data-testid="buy-page">
      <PageBand title={b.title} subtitle={b.subtitle} id="buy" />
      <section className="max-w-[1180px] mx-auto px-6 py-16 lg:py-24 grid gap-12 md:grid-cols-[minmax(0,300px)_1fr] items-start">
        <img src={assetUrl(b.image)} alt={b.title} className="w-full max-w-[300px] h-auto rounded-md shadow-2xl mx-auto" data-testid="buy-image" />
        <div>
          <Rich html={b.body} className="text-charcoal/80 text-base" />
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={`mailto:${content.contact.email}?subject=${encodeURIComponent("Order Print Edition – ISD")}`} className="inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white px-6 py-3 text-sm font-bold transition-colors" data-testid="buy-order-button">
              <Mail className="h-4 w-4" />{b.btn_order}
            </a>
            <Link to="/digital-edition" className="inline-flex items-center gap-2 rounded-full border-2 border-brand text-brand hover:bg-brand hover:text-white px-6 py-3 text-sm font-bold transition-colors" data-testid="buy-digital-button">
              <BookOpen className="h-4 w-4" />{b.btn_digital}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
